
let timer;
export default {
	async signup(context, payload) {
		const response = await fetch(
			'https://identitytoolkit.googleapis.com/v1/accounts:signUp?key=' + process.env.VUE_APP_FB_KEY,
			{
				method: 'POST',
				body: JSON.stringify({
					email: payload.email,
					password: payload.password,
					returnSecureToken: true,
				}),
			}
		);

		const responseData = await response.json();
		if (!response.ok) {
			const error = new Error(responseData.message || 'There was an error. Please try again.');
			throw error;
		}
		const expiresIn = +responseData.expiresIn * 1000;
		// const expiresIn = 5000;
		const expirationDate = new Date().getTime() + expiresIn;

		localStorage.setItem('token', responseData.idToken);
		localStorage.setItem('userId', responseData.localId);
		localStorage.setItem('tokenExpiration', expirationDate);
		context.commit('setUser', {
			token: responseData.idToken,
			userId: responseData.localId,
			email: responseData.email,
		});
	},
	async signIn(context, payload) {
		const response = await fetch(
			'https://identitytoolkit.googleapis.com/v1/accounts:signInWithPassword?key=' + process.env.VUE_APP_FB_KEY,
			{
				method: 'POST',
				body: JSON.stringify({
					email: payload.email,
					password: payload.password,
					returnSecureToken: true,
				}),
			}
		);

		const responseData = await response.json();
		if (!response.ok) {
			const error = new Error(responseData.message || 'There was an error. Please try again.');
			throw error;
		}
		const expiresIn = +responseData.expiresIn * 10000 ;
		const expirationDate = new Date().getTime() + expiresIn;

		localStorage.setItem('token', responseData.idToken);
		localStorage.setItem('userId', responseData.localId);
		localStorage.setItem('tokenExpiration', expirationDate);

		timer = setTimeout(() => {
			context.dispatch('autoLogout');
		}, expiresIn);

		context.commit('setUser', {
			token: responseData.idToken,
			userId: responseData.localId,
			email: responseData.email,
		});
	},
	async userInfo(context, payload) {
		const token = localStorage.getItem('token');
		const userId = context.rootGetters.userId;
		const userInfo = {
			userType: payload.userType,
			firstName: payload.firstName,
			lastName: payload.lastName,
			email: payload.email,
			league: payload.league,
			leagueId: payload.leagueId,
			division: payload.division,
			divisionId: payload.divisionId,
			team: payload.team,
			teamId: payload.teamId,
		};
		const response = await fetch(
			`https://six4three-7a0ac-default-rtdb.firebaseio.com/users/${userId}.json?auth=` + token,
			{
				method: 'PUT',
				body: JSON.stringify(userInfo),
			}
		);
		const responseData = await response.json();
		if (!response.ok) {
			const error = new Error(responseData.message || 'Failed to fetch tickets.');
			throw error;
		}
		localStorage.setItem('email', responseData.email);
		localStorage.setItem('userType', responseData.userType);
		localStorage.setItem('firstName', responseData.firstName);
		localStorage.setItem('lastName', responseData.lastName);
		localStorage.setItem('league', responseData.league);
		localStorage.setItem('leagueId', responseData.leagueId);
		localStorage.setItem('division', responseData.division);
		localStorage.setItem('divisionId', responseData.divisionId);
		localStorage.setItem('team', responseData.team);
		localStorage.setItem('teamId', responseData.teamId);

		context.commit('setUserInfo', {
			userType: responseData.userType,
			firstName: responseData.firstName,
			lastName: responseData.lastName,
			email: responseData.email,
			league: responseData.league,
			divisionId: responseData.divisionId,
			division: responseData.division,
			leagueId: responseData.leagueId,
			team: responseData.team,
			teamId: responseData.teamId,
		});
	},
	async editedUserInfo(context, payload) {
		const token = localStorage.getItem('token');
		const userId = context.rootGetters.userId;
		const userInfo = {
			firstName: payload.firstName,
			lastName: payload.lastName,
			positions: payload.positions,
			number: payload.number
		};
		const response = await fetch(
			`https://six4three-7a0ac-default-rtdb.firebaseio.com/users/${userId}.json?auth=` + token,
			{
				method: 'PATCH',
				body: JSON.stringify(userInfo),
			}
		);
		const responseData = await response.json();
		if (!response.ok) {
			const error = new Error(responseData.message || 'Failed to fetch tickets.');
			throw error;
		}
		localStorage.setItem('firstName', responseData.firstName);
		localStorage.setItem('lastName', responseData.lastName);
		context.commit('setUserInfo', {
			userFName: responseData.firstName,
			userLName: responseData.lastName,
			positions: responseData.positions,
			number: responseData.number
		});
	},
	async setUserLeague(context, payload) {
		const token = localStorage.getItem('token');
		const userId = localStorage.getItem('userId');
		const leagueInfo = {
			league: payload.league.league,
			leagueId: payload.leagueId,
			division: payload.division,
			divisionId: payload.divisionId,
		};
		const response = await fetch(
			`https://six4three-7a0ac-default-rtdb.firebaseio.com/users/${userId}.json?auth=` + token,
			{
				method: 'PATCH',
				body: JSON.stringify(leagueInfo),
			}
		);
		const responseData = await response.json();
		if (!response.ok) {
			const error = new Error(responseData.message || 'Failed to fetch leagues.');
			throw error;
		}
		localStorage.setItem('leagueId', responseData.leagueId);
		localStorage.setItem('league', responseData.league);
		localStorage.setItem('divisionId', responseData.divisionId);
		localStorage.setItem('division', responseData.division);
		context.commit('setUserLeague', {
			league: responseData.league,
			leagueId: responseData.leagueId,
			division: responseData.division,
			divisionId: responseData.divisionId,
		});
	},
	async setUserTeam(context, payload) {
		const token = localStorage.getItem('token');
		const userId = localStorage.getItem('userId');
		const teamInfo = {
			team: payload.team,
			teamId: payload.teamId,
		};
		const response = await fetch(
			`https://six4three-7a0ac-default-rtdb.firebaseio.com/users/${userId}.json?auth=` + token,
			{
				method: 'PATCH',
				body: JSON.stringify(teamInfo),
			}
		);
		const responseData = await response.json();
		if (!response.ok) {
			const error = new Error(responseData.message || 'Failed to fetch teams.');
			throw error;
		}
		localStorage.setItem('userTeam', responseData.team);
		context.commit('setUserTeam', {
			userTeam: responseData.team,
		});
	},
	async fetchUserData(context) {
		const token = localStorage.getItem('token');
		const userId = context.rootGetters.userId;
		// const userId = localStorage.getItem("userId");
		const response = await fetch(
			`https://six4three-7a0ac-default-rtdb.firebaseio.com/users/${userId}.json?auth=` + token
		);
		const responseData = await response.json();

		if (!response.ok) {
			const error = new Error(responseData.message || 'Failed');
			throw error;
		}
		localStorage.setItem('email', responseData.email);
		localStorage.setItem('userType', responseData.userType);
		localStorage.setItem('firstName', responseData.firstName);
		localStorage.setItem('lastName', responseData.lastName);
		localStorage.setItem('league', responseData.league);
		localStorage.setItem('leagueId', responseData.leagueId);
		localStorage.setItem('division', responseData.division);
		localStorage.setItem('divisionId', responseData.divisionId);
		localStorage.setItem('team', responseData.team);
		localStorage.setItem('teamId', responseData.teamId);

		context.commit('setUserInfo', {
			email: responseData.userEmail,
			userType: responseData.userType,
			firstName: responseData.firstName,
			lastName: responseData.lastName,
			league: responseData.league,
			leagueId: responseData.leagueId,
			division: responseData.division,
			divisionId: responseData.divisionId,
			team: responseData.team,
			teamId: responseData.teamId,
			stats: responseData.stats,
			number: responseData.number
		});
		context.commit('setUserLeague', {
			league: responseData.league,
			leagueId: responseData.leagueId,
			division: responseData.division,
			divisionId: responseData.divisionId,
		});
	},
	async fetchUsers(context) {
		const token = localStorage.getItem('token');
		const response = await fetch(`https://six4three-7a0ac-default-rtdb.firebaseio.com/users.json?auth=` + token);
		const responseData = await response.json();

		if (!response.ok) {
			const error = new Error(responseData.message || 'Failed');
			throw error;
		}
		const users = [];
		for (const key in responseData) {
			const user = {
				id: key,
				firstName: responseData[key].firstName,
				lastName: responseData[key].lastName,
				team: responseData[key].team,
				league: responseData[key].league,
				leagueId: responseData[key].leagueId,
				division: responseData[key].division,
				divisionId: responseData[key].divisionId,
				positions: responseData[key].positions,
				stats: responseData[key].stats,
				email: responseData[key].email,
				userType: responseData[key].userType,
				number: responseData[key].number
			};
			users.push(user);
		}
		context.commit('setAllUsers', users);
	},
	logout(context) {
		localStorage.removeItem('token');
		localStorage.removeItem('userId');
		localStorage.removeItem('tokenExpiration');
		localStorage.removeItem('email');
		localStorage.removeItem('userType');
		localStorage.removeItem('firstName');
		localStorage.removeItem('lastName');
		localStorage.removeItem('league');
		localStorage.removeItem('leagueId');
		localStorage.removeItem('division');
		localStorage.removeItem('divisionId');
		localStorage.removeItem('team');
		localStorage.removeItem('teamId');
		localStorage.removeItem('notificationStatus');

		clearTimeout(timer);

		context.commit('setUser', {
			token: null,
			userId: null,
		});
	},
	//////// need to set up auto login
	tryLogin(context, dispatch) {
		const token = localStorage.getItem('token');
		const userId = localStorage.getItem('userId');
		const tokenExpiration = localStorage.getItem('tokenExpiration');
		const email = localStorage.getItem('email');
		const userType = localStorage.getItem('userType');
		const firstName = localStorage.getItem('firstName');
		const lastName = localStorage.getItem('lastName');
		const league = localStorage.getItem('league');
		const leagueId = localStorage.getItem('leagueId');
		const division = localStorage.getItem('division');
		const divisionId = localStorage.getItem('divisionId');
		const team = localStorage.getItem('team');
		const teamId = localStorage.getItem('teamId');
		const notifications = localStorage.getItem('notificationStatus');

		const expiresIn = +tokenExpiration - new Date().getTime();

		if (expiresIn < 0) {
			return;
		}

		timer = setTimeout(() => {
			context.dispatch('autoLogout');
		}, expiresIn);

		if (userId && email && userType && firstName && lastName) {
			context.commit('setUser', {
				token: token,
				userId: userId,
			});
			context.commit('setUserInfo', {
				email: email,
				userType: userType,
				firstName: firstName,
				lastName: lastName,
				league: league,
				leagueId: leagueId,
				division: division,
				divisionId: divisionId,
				team: team,
				teamId: teamId,
			});
			context.commit('notifications/setNotificationStatus', notifications);
			context.dispatch('notifications/fetchNotifications');
		}
	},
	autoLogout(context) {
		context.dispatch('logout');
		context.commit('setAutoLogout');
	},
	setComponentKey(context) {
		const payload = 1;
		context.commit('updateComponent', payload);
	},
};
